<div
	class="flex place-self-stretch flex-1 justify-center items-center bg-gray-50"
>
	<img
		src="/assets/images/undraw/undraw_maker_launch.svg"
		class="max-w-250 w-full"
	/>
</div>

<div class="w-full p-8">
	<div class="h-full w-full flex flex-col">
		<div class="flex-1 flex">
			<div class="flex flex-col overflow-hidden">
				<div class="flex flex-col flex-1">
					<ui-note
						*ngIf="
							(isAIEnabled$ | async) &&
							(isIntroduceAiCreateMatterModalHidden$ | async) === false
						"
						title="Introducing AI"
						callToActionType="CLOSE"
						[omitCloseLogic]="true"
						[type]="NOTE_TYPES.CUSTOM_WHITE"
						[icon]="'sparkles'"
						[iconClasses]="'text-purple-800 bg-purple-50 rounded-md'"
						(callToActionClick)="hideIntroduceAiCreateMatterModal()"
						[testHook]="testHooks.IntroducingAiNote"
					>
						<p>
							Enable AI to instantly extract and autofill essential information
							from your documents, making your process faster and easier.
						</p>
					</ui-note>

					<div class="flex justify-between items-center mb-4">
						<h3 class="text-lg font-bold">Upload Important Documents:</h3>
					</div>
					<p>{{ AI_Text$ | async }}</p>

					<div class="mt-8">
						<div class="flex justify-between items-center mb-4">
							<h4 class="font-bold heading--5">
								Agreement of Purchase and Sale (APS)
							</h4>
							<app-ai-document-toggle
								[matterId]="_matterId"
								[matterDocumentTypes]="[matterDocumentTypes.APS]"
								[isChecked]="isAiApsToggleChecked"
								(onChange)="onAiApsToggleChanged($event)"
								[testHook]="testHooks.AiDocumentToggle"
							/>
						</div>

						<div *ngIf="!apsFile">
							<atomic-dropzone
								class="text-center"
								*ngIf="
									addCommissionStatements ||
									matterType !== matterFileType.PURCHASE
								"
								size="extra-compact"
								(fileChanged)="onAPSFileSelected($event)"
								[testHook]="testHooks.Dropzone"
							></atomic-dropzone>
							<atomic-dropzone
								class="text-center"
								*ngIf="
									!addCommissionStatements &&
									matterType === matterFileType.PURCHASE
								"
								(fileChanged)="onAPSFileSelected($event)"
								[testHook]="testHooks.Dropzone1"
							></atomic-dropzone>
						</div>

						<app-internet-file
							actionType="upload"
							*ngIf="apsFile"
							[documentName]="apsFile?.name"
							(onAction)="removeAPSFile()"
							[testHook]="testHooks.InternetFile"
						>
						</app-internet-file>
					</div>

					<app-checkbox
						type="clear"
						*ngIf="matterType === matterFileType.PURCHASE"
						label="Add Buyer Brokerage Commission Statement"
						[(ngModel)]="addCommissionStatements"
						class="mt-4"
						[testHook]="testHooks.AddCommissionStatementCheckbox"
					></app-checkbox>

					<div
						class="mt-8"
						*ngIf="
							addCommissionStatements || matterType !== matterFileType.PURCHASE
						"
						[@openClose]
					>
						<div class="flex justify-between items-center mb-4">
							<h4 class="font-bold heading--5">
								Commission
								{{
									matterType === matterFileType.PURCHASE
										? 'Statement'
										: 'Statements'
								}}
							</h4>
							<app-ai-document-toggle
								[matterId]="_matterId"
								[isChecked]="isAiCommissionToggleChecked"
								[matterDocumentTypes]="[
									matterDocumentTypes.SELLER_COMMISSION_STATEMENT,
									matterDocumentTypes.BUYER_COMMISSION_STATEMENT,
								]"
								(onChange)="onAiCommissionToggleChanged($event)"
								[testHook]="testHooks.AiDocumentToggle1"
							/>
						</div>

						<div>
							<div class="mb-3" *ngIf="matterType !== matterFileType.PURCHASE">
								<h4 class="text-sm">Seller Brokerage Commission Statement</h4>
								<atomic-dropzone
									*ngIf="!sellerCommissionStatementFile"
									size="extra-compact"
									(fileChanged)="
										onCommissionStatementFileSelected(
											$event,
											brokerageType.SELLER_BROKERAGE
										)
									"
									[testHook]="testHooks.Dropzone2"
								></atomic-dropzone>
								<app-internet-file
									actionType="upload"
									*ngIf="sellerCommissionStatementFile"
									[documentName]="sellerCommissionStatementFile?.name"
									(onAction)="
										removeCommissionStatementFile(
											brokerageType.SELLER_BROKERAGE
										)
									"
									[testHook]="testHooks.InternetFile1"
								>
								</app-internet-file>
							</div>

							<div class="mt-6" *ngIf="matterType !== matterFileType.PURCHASE">
								<app-checkbox
									type="clear"
									label="Add Buyer Brokerage Commission Statement"
									[(ngModel)]="addBuyerCommissionStatement"
									[testHook]="
										testHooks.AddBuyerBrokerageCommissionStatementCheckbox
									"
								></app-checkbox>
							</div>

							<div
								class="mt-5"
								*ngIf="
									addBuyerCommissionStatement ||
									matterType === matterFileType.PURCHASE
								"
								[@openClose]
							>
								<h4 class="text-sm">Buyer Brokerage Commission Statement</h4>
								<atomic-dropzone
									*ngIf="!buyerCommissionStatementFile"
									size="extra-compact"
									(fileChanged)="
										onCommissionStatementFileSelected(
											$event,
											brokerageType.BUYER_BROKERAGE
										)
									"
									[testHook]="testHooks.Dropzone3"
								></atomic-dropzone>
								<app-internet-file
									actionType="upload"
									*ngIf="buyerCommissionStatementFile"
									[documentName]="buyerCommissionStatementFile?.name"
									(onAction)="
										removeCommissionStatementFile(brokerageType.BUYER_BROKERAGE)
									"
									[testHook]="testHooks.InternetFile2"
								>
								</app-internet-file>
							</div>
						</div>
					</div>
				</div>

				<div class="w-full justify-end flex gap-6 pb-4 pt-8">
					<ui-button
						(click)="uploadFiles()"
						[style]="'outline'"
						[color]="'secondary'"
						[label]="'Skip'"
						[loading]="uploading && !disableSkip"
						[disabled]="disableSkip"
						[testHook]="testHooks.UploadFilesButton"
					></ui-button>
					<ui-button
						(click)="uploadFiles()"
						preset="HIGH_EMPHASIS"
						label="Continue"
						[loading]="uploading && disableSkip"
						[disabled]="!disableSkip"
						[testHook]="testHooks.ContinueButton"
					>
					</ui-button>
				</div>

				<atomic-message-bar
					type="error"
					class="mt-5"
					*ngIf="error"
					[@openClose]
					[testHook]="testHooks.MessageBar"
				>
					There was an error when uploading a file. You can upload the file
					later if the problem persists.
				</atomic-message-bar>
			</div>
		</div>
	</div>
</div>
